import { ListReducerBuilder } from 'src/utils/reducers';
import { IDENTIFIER } from '../actions';

export default {
    awards: ListReducerBuilder.build(IDENTIFIER, false)
};
